import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ItemDTO } from '../models/itemDto';
import { environment, MyHttpClientFactory, DataService } from '@ups/xplat/core';

@Injectable({
  providedIn: 'root',
})
export class TetheringService extends DataService<ItemDTO> {
  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/tethering',
      httpClient,
      httpFactory
    );
  }
}
